// src/pages/product/CRMPage.js
import FeaturePageTemplate from './FeaturePageTemplate';

export default function CRMPage() {
  return <FeaturePageTemplate slug="crm" />;
}